import { useEffect } from 'react'
import { supabase } from '../lib/supabase'

export function AuthCallback() {
  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Handle the OAuth callback
        const { data, error } = await supabase.auth.getSession()
        
        if (error) {
          console.error('Auth callback error:', error)
          window.location.href = '/?error=' + encodeURIComponent(error.message)
          return
        }

        if (data.session) {
          console.log('✅ Auth callback successful, user logged in')
          // Small delay to allow auth state to update
          setTimeout(() => {
            window.location.href = '/'
          }, 100)
        } else {
          console.log('❌ No session found in callback')
          window.location.href = '/'
        }
      } catch (error) {
        console.error('Auth callback exception:', error)
        window.location.href = '/?error=' + encodeURIComponent('שגיאה בהתחברות')
      }
    }

    handleAuthCallback()
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" dir="rtl">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-lg font-medium text-gray-900 font-hebrew">
          מתחבר...
        </h2>
        <p className="text-gray-600 font-hebrew mt-2">
          אנא המתן בזמן שאנחנו מתחברים אותך למערכת
        </p>
      </div>
    </div>
  )
}